// extracted by mini-css-extract-plugin
export default {"header":"HeaderFooter_header__NpRZj","header_staff":"HeaderFooter_header_staff__X8RTU","footer":"HeaderFooter_footer__vdL8Q","container":"HeaderFooter_container__vvzjv"};